/*
  Sends the club CTAs straight into checkout with the membership as the only line item,
  so a shopper's retail cart can never be merged into (and delay) a club order.

  This has to run in JS rather than as a plain /cart/clear?return_to=... permalink:
  Rebuy Smart Cart intercepts clicks on any link whose href points at /cart and opens
  its flyout instead of navigating. The anchors therefore point at the product page
  (a href Rebuy ignores, and a sane no-JS fallback) and we do the work here.
*/
document.querySelectorAll('[data-frey-ranch-checkout]').forEach((trigger) => {
  trigger.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (trigger.hasAttribute('aria-busy')) return;
    trigger.setAttribute('aria-busy', 'true');

    const spinner = trigger.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const body = {
      items: [
        {
          id: Number(trigger.dataset.variantId),
          quantity: 1,
          selling_plan: Number(trigger.dataset.sellingPlanId),
        },
      ],
    };

    try {
      await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error(`cart/add.js responded ${response.status}`);

      window.location.href = `${root}checkout`;
    } catch (error) {
      console.error('Frey Ranch club checkout failed', error);
      trigger.removeAttribute('aria-busy');
      if (spinner) spinner.classList.add('hidden');
      window.location.href = trigger.href;
    }
  });
});
